class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      let oneIndex = this.dataset.index;
      let key = this.dataset.key;


        cartItems.updateQuantity(oneIndex, 0, "", key);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartCheckoutButton extends HTMLElement {
  constructor() {
    super();

    this.querySelector('button').addEventListener('click', () => {
      let carePlanAdded = false;
      document.querySelectorAll('.cart-item').forEach(item => {
        if (item.dataset.title === 'Birdie Care Plan') {
          carePlanAdded = true;
        }
      })

      if (carePlanAdded) {
        window.location.href = "/checkout"
      } else {
        if (window.warrantyActive) {
          console.log(window.pv)
          let formData;
          if (window.pv === 'v1') {
            // add increased price birdie
            formData = {
              items: [
                {
                  id: '43653782798511',
                  quantity: 1
                }
              ]
            };
          } else if (window.pv === 'v2') {
            formData = {
              items: [
                {
                  id: '44371628359855',
                  quantity: 1
                }
              ]
            };

          } else if (window.pv === 'v3') {
            formData = {
              items: [
                {
                  id: '44423581401263',
                  quantity: 1
                }
              ]
            };

          } else if (window.pv === 'v4') {
            formData = {
              items: [
                {
                  id: '44423590183087',
                  quantity: 1
                }
              ]
            };

          } else if (window.pv === 'v5') {
            formData = {
              items: [
                {
                  id: '44423591657647',
                  quantity: 1
                }
              ]
            };            
          } else {
            formData = {
              items: [
                {
                  id: '43653782798511',
                  quantity: 1
                }
              ]
            };
          }

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
          .then((response) => {
            window.location.href = "/checkout"
          })
        } else {
          window.location.href = "/checkout"
        }
      }

    })
  }
}

customElements.define("cart-checkout-button", CartCheckoutButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));

    this.initPressSlider();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }

    try {
      this.pressSlider?.destroy();
    } catch (error) {
      console.log('Press slider destroy error', error);
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.parentElement.dataset.key
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  initPressSlider() {
    const pressSlider = document.querySelector('.drawer__empty-cart-press');
    console.log('pressSlider', pressSlider)
    if (!pressSlider) return;

    this.pressSlider = new Glide('.drawer__empty-cart-press', {
      type: 'carousel',
      perView: 1,
      autoplay: 5000,
      dots: false,
      peek: 0
    });

    this.pressSlider.mount();
  }

  updateQuantity(line, quantity, name, key) {
    this.enableLoading(line);
    this.startLoad();
    updateCartProgressBar();


    let updates = {
      [key]: quantity,
    };
    let body = JSON.stringify({
      updates: updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    let sectionsToRender = this.getSectionsToRender().map(
      (section) => section.id
    );

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        // parsedState['sections'] = sectionsToRender
        // parsedState['sections_url'] = window.location.pathname

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          updateCartProgressBar();
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
        
        // Check for birdie-plus items and manage subscription
        if (window.birdiePlusSubscriptionHandler) {
          setTimeout(() => {
            window.birdiePlusSubscriptionHandler.checkForBirdiePlusItems();
          }, 200);
        }

        // Restore Spring / igTestGroups promo banner (section HTML resets to theme customizer)
        if (typeof window.applySpringCopyFromCart === 'function') {
          window.applySpringCopyFromCart();
        }
      })
      .catch((e) => {
        console.log(e);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
          if(errors) {
            errors.textContent = window.cartStrings.error;
          }
      })
      .finally(() => {
        window.setTimeout(() => {
          this.endLoad();
        }, 150);
        this.disableLoading(line);
        this.initPressSlider();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  startLoad() {
    document.querySelector(".birdie-loader__inner").style.display = "block";
  }

  endLoad() {
    document.querySelector(".birdie-loader__inner").style.display = "none";
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    // Use event delegation for overlay clicks - this works even if overlay is dynamically created
    this.addEventListener('click', (event) => {
      if (event.target && event.target.id === 'CartDrawer-Overlay') {
        console.log('🖱️ Overlay clicked - closing cart drawer');
        this.close();
      }
    });
    
    // Also try direct listener as backup
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
      console.log('✅ Cart drawer overlay click listener added (direct)');
    } else {
      console.warn('❌ Cart drawer overlay not found initially, using event delegation');
    }
    
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    if (localStorage.getItem('openCartDrawer')) {
      this.open();
      localStorage.removeItem('openCartDrawer');
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    if (this.classList.contains('is-empty')) {
      gtag('event', 'empty_vart_view', {
        'count': '1'
      });
    }

    document.body.classList.add('overflow-hidden');

    // Notify listeners (progress bar, B2G1 sync, subscription handler)
    document.dispatchEvent(new CustomEvent('cart-drawer:opened'));
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log(parsedState)
    if(parsedState.message != undefined && document.querySelectorAll('.product-form__error-message').length > 0) {
      document.querySelector('.product-form__error-message').innerHTML = parsedState.message;
    }
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      console.log('section')
      console.log(section)
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      // Re-add overlay click listener after content update
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        // Remove existing listener to prevent duplicates
        overlay.removeEventListener('click', this.close.bind(this));
        overlay.addEventListener('click', this.close.bind(this));
        console.log('✅ Cart drawer overlay click listener re-added after content update');
      } else {
        console.warn('❌ Cart drawer overlay not found after content update');
      }
      
      this.open();
      
      // Check for birdie-plus items and manage subscription
      if (window.birdiePlusSubscriptionHandler) {
        setTimeout(() => {
          window.birdiePlusSubscriptionHandler.checkForBirdiePlusItems();
        }, 300);
      }

      // Spring / igTestGroups promo copy (theme resets banner HTML on each cart section refresh)
      if (typeof window.applySpringCopyFromCart === 'function') {
        window.applySpringCopyFromCart();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


// Custom

class CartSubscription extends HTMLElement {
  constructor() {
    super();

    this.variant = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.submitButton = this.querySelector('.cart-subscription__submit');

    this.submitButton?.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  async onSubmitHandler(event) {
    event.preventDefault();

    this.submitButton.disabled = true;
    this.submitButton.classList.add('loading');
    this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    try {
      const cartResponse = await fetch(`${routes.cart_url}.js`);
      const cartData = await cartResponse.json();

      const birdiePlusItems = cartData.items.filter(item => item.product_id == 7267867689135);
      const birdiePlusQuantity = birdiePlusItems.reduce((acc, item) => acc + item.quantity, 0);

      const formData = new FormData();
      const sellingPlan = this.variant.selling_plan_allocations && this.variant.selling_plan_allocations[0];

      formData['id'] = this.variant.id;
      formData['quantity'] = birdiePlusQuantity;
      formData['selling_plan'] = sellingPlan?.selling_plan_id || '';

      // Get cart drawer for sections
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-drawer-new');
      if (cart) {
        const sectionRender = cart.getSectionsToRender().map(function(section) {
          return section.id;
        });

        formData.sections = sectionRender;
        formData.sections_url = window.location.pathname;
      }

      // Submit via AJAX
      const response = await fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), ...{ body: JSON.stringify(formData) }});
      if (!response.ok) {
        throw new Error('Failed to add subscription to cart');
      }

      const responseData = await response.json();
      cart.renderContents(responseData);
    } catch (error) {
      console.error('Error adding subscription to cart:', error);
    } finally {
      this.submitButton.disabled = false;
      this.submitButton.classList.remove('loading');
      this.submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }
  }
}

if (!customElements.get('cart-subscription')) {
  customElements.define('cart-subscription', CartSubscription);
}

// Color Swatch Functionality
class ColorSwatchHandler {
  constructor() {
    // Singleton — only bind the document listener once to prevent duplicates
    if (ColorSwatchHandler._initialized) return;
    ColorSwatchHandler._initialized = true;
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Handle "Change Color" button clicks
    document.addEventListener('click', (e) => {
      if (e.target.closest('.cart-drawer-new__color-swatches-button')) {
        e.preventDefault();
        this.toggleSwatches(e.target.closest('.cart-drawer-new__color-swatches-button'));
      }

      // Handle color swatch clicks
      if (e.target.closest('.cart-drawer-new__color-swatch')) {
        e.preventDefault();
        this.handleSwatchClick(e.target.closest('.cart-drawer-new__color-swatch'));
      }

      // Close swatches when clicking outside
      if (!e.target.closest('.cart-drawer-new__color-swatches') && 
          !e.target.closest('.cart-drawer-new__color-swatches-button')) {
        this.closeAllSwatches();
      }
    });
  }

  toggleSwatches(button) {
    const cartItem = button.closest('.cart-item');
    const swatchesContainer = cartItem.querySelector('.cart-drawer-new__color-swatches');

    if (swatchesContainer) {
      const isVisible = swatchesContainer.style.display !== 'none';

      // Close all other swatches first
      this.closeAllSwatches();

      if (!isVisible) {
        swatchesContainer.style.display = 'flex';
        button.classList.add('active');
      }
    }
  }

  closeAllSwatches() {
    document.querySelectorAll('.cart-drawer-new__color-swatches').forEach(swatches => {
      swatches.style.display = 'none';
    });
    document.querySelectorAll('.cart-drawer-new__color-swatches-button').forEach(button => {
      button.classList.remove('active');
    });
  }

  async handleSwatchClick(swatch) {
    const cartItem = swatch.closest('.cart-item');
    const currentKey = swatch.dataset.currentKey;
    const newVariantId = swatch.dataset.variantId;
    const colorName = swatch.dataset.colorName;
    const imageUrl = swatch.dataset.imageUrl;
    const imageAlt = swatch.dataset.imageAlt;

    console.log('Color swatch clicked:', {
      currentKey,
      newVariantId,
      colorName,
      imageUrl,
      imageAlt
    });

    // Show both per-item loading and global loader.
    // The per-item overlay covers the current item visually, while the
    // global loader survives the DOM replacement from refreshCartDrawer().
    this.showLoadingState(cartItem);
    this.showGlobalLoader();

    try {
      const updates = {
        [currentKey]: 0
      };

      const body = JSON.stringify({
        updates: updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      // Remove current item first (mark as sync to prevent B2G1 race condition
      // AND to prevent the fetch interceptor from clearing loading too early)
      const removeConfig = fetchConfig();
      removeConfig.headers = removeConfig.headers || {};
      removeConfig.headers['X-Buy-X-Get-Y-Sync'] = '1';
      removeConfig.headers['X-Color-Swatch-Swap'] = '1';
      const removeResponse = await fetch(`${routes.cart_update_url}`, { 
        ...removeConfig, 
        ...{ body } 
      });

      if (!removeResponse.ok) {
        throw new Error('Failed to remove current item');
      }

      // Preserve B2G1 free item property when swapping colors
      const b2g1Value = cartItem.dataset.b2g1Free;
      const addItemPayload = {
        id: newVariantId,
        quantity: this.getCurrentQuantity(cartItem)
      };
      if (b2g1Value) {
        addItemPayload.properties = { '_buy_x_get_y_free': b2g1Value };
      }

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Buy-X-Get-Y-Sync': '1',
          'X-Color-Swatch-Swap': '1',
        },
        body: JSON.stringify({
          items: [addItemPayload]
        })
      });

      if (addResponse.ok) {
        // Refresh the entire cart drawer with server-rendered HTML.
        // Loading stays visible until this completes and new DOM is in place.
        await this.refreshCartDrawer();

        this.closeAllSwatches();
      } else {
        const errorText = await addResponse.text();
        console.error('Failed to add new variant:', errorText);
        throw new Error('Failed to add new variant');
      }
    } catch (error) {
      console.error('Error updating color:', error);
      this.showError(cartItem, 'Failed to update color. Please try again.');
    } finally {
      this.hideGlobalLoader();
    }
  }

  getLineIndex(cartItem) {
    const itemId = cartItem.id;
    return parseInt(itemId.split('-').pop()) - 1;
  }

  getCurrentQuantity(cartItem) {
    const quantityInput = cartItem.querySelector('.quantity__input');
    return parseInt(quantityInput.value) || 1;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  showLoadingState(cartItem) {
    // Show loading overlay
    const loadingOverlay = cartItem.querySelector('.cart-item__loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'flex';
    }

    // Add loading class to cart item
    cartItem.classList.add('loading');

    // Disable swatches container
    const swatchesContainer = cartItem.querySelector('.cart-drawer-new__color-swatches');
    if (swatchesContainer) {
      swatchesContainer.style.pointerEvents = 'none';
      swatchesContainer.style.opacity = '0.5';
    }
  }

  hideLoadingState(cartItem) {
    // Hide loading overlay
    const loadingOverlay = cartItem.querySelector('.cart-item__loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'none';
    }

    // Remove loading class from cart item
    cartItem.classList.remove('loading');

    // Re-enable swatches container
    const swatchesContainer = cartItem.querySelector('.cart-drawer-new__color-swatches');
    if (swatchesContainer) {
      swatchesContainer.style.pointerEvents = 'auto';
      swatchesContainer.style.opacity = '1';
    }
  }

  showGlobalLoader() {
    const loader = document.querySelector('.birdie-loader__inner');
    if (loader) loader.style.display = 'block';
  }

  hideGlobalLoader() {
    const loader = document.querySelector('.birdie-loader__inner');
    if (loader) loader.style.display = 'none';
  }

  async refreshCartDrawer() {
    try {
      // Use the same approach as the existing cart update functionality
      const response = await fetch('/cart?section_id=cart-drawer');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update cart drawer content
      const newCartItems = doc.querySelector('#CartDrawer-CartItems');
      const currentCartItems = document.querySelector('#CartDrawer-CartItems');

      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
      }

      // Update cart totals
      const newTotals = doc.querySelector('.totals');
      const currentTotals = document.querySelector('.totals');

      if (newTotals && currentTotals) {
        currentTotals.innerHTML = newTotals.innerHTML;
      }

      // Update cart icon bubble
      const newCartIcon = doc.querySelector('#cart-icon-bubble');
      const currentCartIcon = document.querySelector('#cart-icon-bubble');

      if (newCartIcon && currentCartIcon) {
        currentCartIcon.innerHTML = newCartIcon.innerHTML;
      }

      // Trigger cart update event
      if (typeof publish !== 'undefined' && PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "color-swatch" });
      }
      
      // Check for birdie-plus items and manage subscription
      if (window.birdiePlusSubscriptionHandler) {
        setTimeout(() => {
          window.birdiePlusSubscriptionHandler.checkForBirdiePlusItems();
        }, 200);
      }
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
    }
  }

  showError(cartItem, message) {
    // Create error element
    const errorElement = document.createElement('div');
    errorElement.className = 'cart-swatch-error';
    errorElement.textContent = message;
    errorElement.style.cssText = `
      color: #e74c3c;
      font-size: 12px;
      margin-top: 5px;
      padding: 5px;
      background: #fdf2f2;
      border: 1px solid #fecaca;
      border-radius: 4px;
    `;

    // Remove existing errors
    cartItem.querySelectorAll('.cart-swatch-error').forEach(error => error.remove());

    // Add error to cart item
    const detailsContainer = cartItem.querySelector('.cart-item__details');
    if (detailsContainer) {
      detailsContainer.appendChild(errorElement);

      // Auto-remove error after 5 seconds
      setTimeout(() => {
        errorElement.remove();
      }, 5000);
    }
  }
}

// Initialize color swatch handler when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ColorSwatchHandler();
});

// Re-initialize when cart drawer content is updated
document.addEventListener('cart:updated', () => {
  new ColorSwatchHandler();
});

// Cart Loading Handler



// Initialize cart functionality when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Hook into cart update methods
  setTimeout(() => {
    hookIntoCartUpdates();
    setupCartMutationObserver();
    setupComprehensiveCartDetection();
  }, 1000);
});



// Hook into the actual cart update methods
function hookIntoCartUpdates() {
  console.log('Attempting to hook into cart updates...');

  // Check for cart-drawer-new element
  const cartDrawerNew = document.querySelector('cart-drawer-new');
  console.log('Cart drawer new found:', !!cartDrawerNew);

  if (cartDrawerNew) {
    console.log('Cart drawer methods:', {
      refreshCart: typeof cartDrawerNew.refreshCart,
      updateCartQuantity: typeof cartDrawerNew.updateCartQuantity,
      changeVariantByReplace: typeof cartDrawerNew.changeVariantByReplace
    });
  }

  // Override the refreshCart method in cart-drawer-new.js
  if (cartDrawerNew && cartDrawerNew.refreshCart) {
    console.log('Hooking into refreshCart method...');
    const originalRefreshCart = cartDrawerNew.refreshCart.bind(cartDrawerNew);
    cartDrawerNew.refreshCart = function() {
      console.log('Cart drawer refresh detected...');
      return originalRefreshCart().then(() => {
        // Hide loading state for all cart items
        document.querySelectorAll('.cart-item.loading').forEach(cartItem => {
          hideCartItemLoading(cartItem);
        });
      });
    };
  }

  // Override the updateCartQuantity method in cart-drawer-new.js
  if (cartDrawerNew && cartDrawerNew.updateCartQuantity) {
    console.log('Hooking into updateCartQuantity method...');
    const originalUpdateCartQuantity = cartDrawerNew.updateCartQuantity.bind(cartDrawerNew);
    cartDrawerNew.updateCartQuantity = function(key, quantity) {
      console.log('Cart quantity update detected...');
      return originalUpdateCartQuantity(key, quantity).then(() => {
        // Hide loading state for all cart items
        document.querySelectorAll('.cart-item.loading').forEach(cartItem => {
          hideCartItemLoading(cartItem);
        });
      });
    };
  }

  // Override the changeVariantByReplace method for color changes
  if (cartDrawerNew && cartDrawerNew.changeVariantByReplace) {
    console.log('Hooking into changeVariantByReplace method...');
    const originalChangeVariant = cartDrawerNew.changeVariantByReplace.bind(cartDrawerNew);
    cartDrawerNew.changeVariantByReplace = function(currentKey, newVariantId, currentQuantity) {
      console.log('Color variant change detected...');
      return originalChangeVariant(currentKey, newVariantId, currentQuantity).then(() => {
        // Hide loading state for all cart items
        document.querySelectorAll('.cart-item.loading').forEach(cartItem => {
          hideCartItemLoading(cartItem);
        });
      });
    };
  }

  // Also check for regular cart-drawer
  const cartDrawer = document.querySelector('cart-drawer');
  console.log('Cart drawer found:', !!cartDrawer);

  if (cartDrawer) {
    console.log('Cart drawer methods:', {
      refreshCart: typeof cartDrawer.refreshCart,
      updateQuantity: typeof cartDrawer.updateQuantity
    });
  }
}



// Intercept cart update fetch calls and trigger B2G1 sync
function isCartMutationUrl(url) {
  // Match both /cart/add and /cart/add.js (same for update, change)
  return /\/cart\/(add|update|change)(\.js)?(\?|$)/i.test(url);
}

function interceptCartUpdates() {
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (isCartMutationUrl(url)) {
      const headers = options?.headers || {};
      const isSyncRequest = headers['X-Buy-X-Get-Y-Sync'] === '1'
        || (headers instanceof Headers && headers.get('X-Buy-X-Get-Y-Sync') === '1');

      // Color swatch swaps manage their own loading lifecycle — don't interfere
      const isSwatchSwap = headers['X-Color-Swatch-Swap'] === '1'
        || (headers instanceof Headers && headers.get('X-Color-Swatch-Swap') === '1');

      // Track which variant was just added so B2G1 can make the correct one free
      const isAddUrl = /\/cart\/add(\.js)?(\?|$)/i.test(url);
      if (isAddUrl && !isSyncRequest && window.BuyXGetYFreeManager) {
        try {
          let variantId = null;
          const body = options?.body;

          if (body instanceof FormData) {
            variantId = body.get('id');
          } else if (body instanceof URLSearchParams) {
            variantId = body.get('id');
          } else if (typeof body === 'string') {
            const parsed = JSON.parse(body);
            variantId = parsed?.items?.[0]?.id || parsed?.id;
          } else if (body && typeof body === 'object') {
            variantId = body?.items?.[0]?.id || body?.id;
          }

          if (variantId) {
            window.BuyXGetYFreeManager.lastAddedVariantId = Number(variantId);
          }
        } catch (_) {}
      }

      // Show drawer-level overlay only when stacking is active (2+ free items)
      // to prevent flicker during excess free item cleanup
      const isChangeOrUpdate = /\/cart\/(change|update)(\.js)?(\?|$)/i.test(url);
      if (isChangeOrUpdate && !isSyncRequest && !isSwatchSwap && window.BuyXGetYFreeManager) {
        const freeItemCount = document.querySelectorAll('.cart-item[data-b2g1-free]').length;
        if (freeItemCount >= 2) {
          window.BuyXGetYFreeManager.showDrawerSyncOverlay();
        }
      }

      return originalFetch(url, options).then(response => {
        // Don't clear loading overlays during B2G1 sync — it manages its own lifecycle
        if (response.ok && !isSwatchSwap && !isSyncRequest) {
          document.querySelectorAll('.cart-item.loading').forEach(cartItem => {
            hideCartItemLoading(cartItem);
          });
        }

        // Trigger B2G1 sync after any non-sync cart mutation
        if (response.ok && !isSyncRequest && window.BuyXGetYFreeManager) {
          setTimeout(() => {
            window.BuyXGetYFreeManager.sync();
          }, 50);
        }

        return response;
      }).catch(error => {
        if (!isSwatchSwap && !isSyncRequest) {
          document.querySelectorAll('.cart-item.loading').forEach(cartItem => {
            hideCartItemLoading(cartItem);
          });
          if (window.BuyXGetYFreeManager) {
            window.BuyXGetYFreeManager.hideDrawerSyncOverlay();
          }
        }
        return Promise.reject(error);
      });
    }

    return originalFetch(url, options);
  };
}

// Initialize fetch interception
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    interceptCartUpdates();
  }, 1000);
});

// Listen for cart update button clicks directly
document.addEventListener('click', (e) => {
  // Check if it's a cart update button
  if (e.target.closest('.quantity__button') || 
      e.target.closest('cart-remove-button') ||
      e.target.closest('.cart-drawer-new__color-swatch') ||
      e.target.closest('.cart-drawer-new__qty-button') ||
      e.target.closest('.cart-drawer-new__remove-button')) {
    console.log('Cart update button clicked...');

    // Show loading state for the specific cart item
    const cartItem = e.target.closest('.cart-item');
    if (cartItem) {
      showCartItemLoading(cartItem);
    }
  }
});

// Function to show loading state for cart items
function showCartItemLoading(cartItem) {
  if (cartItem) {
    cartItem.classList.add('loading');

    // Show loading overlay
    const loadingOverlay = cartItem.querySelector('.cart-item__loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'flex';
    }

    // Set a timeout to automatically hide loading state after 10 seconds
    setTimeout(() => {
      if (cartItem.classList.contains('loading')) {
        console.log('Auto-hiding loading state after timeout');
        hideCartItemLoading(cartItem);
      }
    }, 10000);
  }
}

// Function to hide loading state for cart items
function hideCartItemLoading(cartItem) {
  if (cartItem) {
    cartItem.classList.remove('loading');

    // Hide loading overlay
    const loadingOverlay = cartItem.querySelector('.cart-item__loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'none';
    }
  }
}

// Set up mutation observer to watch for cart content changes
function setupCartMutationObserver() {
  const cartItemsContainer = document.querySelector('#CartDrawer-CartItems');
  if (cartItemsContainer) {
    console.log('Setting up mutation observer for cart items...');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.target.id === 'CartDrawer-CartItems') {
          console.log('Cart items container changed...');
        }
      });
    });

    observer.observe(cartItemsContainer, {
      childList: true,
      subtree: true
    });
  }
}

// Manual test function
window.testCartUpdate = function() {
  console.log('Manually testing cart update...');
  console.log('Cart update test completed');
};

// More comprehensive cart update detection
function setupComprehensiveCartDetection() {
  console.log('Setting up comprehensive cart detection...');

  // Listen for all cart-related events
  const cartEvents = ['cart:updated', 'cart:opened', 'cart:closed', 'cart:refresh'];
  cartEvents.forEach(eventName => {
    document.addEventListener(eventName, () => {
      console.log(`Cart event detected: ${eventName}`);
    });
  });

  // Listen for any changes to cart-related elements
  const cartSelectors = [
    '#CartDrawer-CartItems',
    '.cart-drawer-new__items',
    '.cart-drawer-new__item',
    '.cart-drawer-new__progress'
  ];

  cartSelectors.forEach(selector => {
    const element = document.querySelector(selector);
    if (element) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          console.log(`Cart element changed: ${selector}`);
        }
        });
      });

      observer.observe(element, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-*']
      });
    }
  });
}


// progress bar
// Progress Bar Functionality
class CartProgressBar {
  constructor() {
    this.settings = window.cartProgressBarSettings || {};
    this.init();
  }

  init() {
    if (!this.settings.enabled) return;

    this.bindEvents();
    this.setupTitleProtection();
    // Wait a bit for DOM to be fully ready before initial update
    setTimeout(() => {
      this.updateProgressBar();
    }, 100);
  }

  setupTitleProtection() {
    // Simple setup - no complex protection needed
    console.log('Progress bar initialized');
  }

  bindEvents() {
    // Update progress bar when cart changes
    document.addEventListener('cart:updated', (event) => {
      // Skip progress bar update if the update was from subscription addition
      if (event.detail && event.detail.source === 'birdie-plus-subscription') {
        console.log('⏭️ Skipping progress bar update for subscription addition');
        return;
      }
      
      setTimeout(() => {
        this.updateProgressBar();
      }, 500); // Delay to ensure cart is fully updated
    });

    // Update when cart drawer is opened
    document.addEventListener('cart-drawer:opened', () => {
      setTimeout(() => {
        this.updateProgressBar();
      }, 300);
    });
  }

  getCartItemCount() {
    try {
      // Get total quantity of non-gift items in cart with birdie-alarm tag
      let totalQuantity = 0;
      const cartItems = document.querySelectorAll('.cart-item');

      cartItems.forEach(item => {
        // Skip items with mystery gift, keychain, or subscription in title
        const itemTitle = item.dataset.title || '';
        if (itemTitle.includes('Mystery Gift') || itemTitle.includes('Keychain') || itemTitle.includes('subscription')) {
          return; // Skip this item
        }

        // Also check for mystery-gift-item and subscription attributes
        if (item.hasAttribute('mystery-gift-item') || item.hasAttribute('data-subscription') || item.classList.contains('subscription')) {
          return; // Skip this item
        }

        // // Check if item has birdie-alarm tag
        // const itemTags = item.dataset.tags || '';
        // if (!itemTags.includes('birdie-alarm')) {
        //   return; // Skip items without birdie-alarm tag
        // }

        const quantityInput = item.querySelector('.quantity__input');
        if (quantityInput) {
          totalQuantity += parseInt(quantityInput.value) || 0;
        }
      });

      return totalQuantity;
    } catch (error) {
      console.error('Error getting cart item count:', error);
      return 0;
    }
  }

  getValidMilestones() {
    try {
      return [
        { qty: this.settings.milestones[0]?.quantity || 0, gift: this.settings.milestones[0]?.gift || '', productTitle: this.settings.milestones[0]?.productTitle || '', index: 1 },
        { qty: this.settings.milestones[1]?.quantity || 0, gift: this.settings.milestones[1]?.gift || '', productTitle: this.settings.milestones[1]?.productTitle || '', index: 2 },
        { qty: this.settings.milestones[2]?.quantity || 0, gift: this.settings.milestones[2]?.gift || '', productTitle: this.settings.milestones[2]?.productTitle || '', index: 3 },
        { qty: this.settings.milestones[3]?.quantity || 0, gift: this.settings.milestones[3]?.gift || '', productTitle: this.settings.milestones[3]?.productTitle || '', index: 4 }
      ].filter(m => m.qty > 0)
       .sort((a, b) => a.qty - b.qty);
    } catch (error) {
      console.error('Error getting valid milestones:', error);
      return [];
    }
  }

  getProgressPercentage(itemCount) {
    try {
      const validMilestones = this.getValidMilestones();

      if (validMilestones.length === 0) {
        return 0; // No valid milestones
      }

      const progressBar = document.querySelector('#cart-progress-bar');
      const barWidth = progressBar ? progressBar.offsetWidth : 300; // Fallback width

      if (barWidth === 0) return 0;

      // Calculate positions for valid milestones only
      const maxQty = Math.max(...validMilestones.map(m => m.qty));
      const milestonePositions = validMilestones.map(m => ({
        qty: m.qty,
        position: (m.qty / maxQty) * barWidth
      }));

      // Find which segment the current itemCount falls into
      let fillWidth = 0;

      if (itemCount < milestonePositions[0].qty) {
        // Before first valid milestone
        fillWidth = (itemCount / milestonePositions[0].qty) * milestonePositions[0].position;
      } else {
        // Find the segment
        let segmentFound = false;
        for (let i = 0; i < milestonePositions.length - 1; i++) {
          if (itemCount >= milestonePositions[i].qty && itemCount < milestonePositions[i + 1].qty) {
            const seg = itemCount - milestonePositions[i].qty;
            const segTotal = milestonePositions[i + 1].qty - milestonePositions[i].qty;
            fillWidth = milestonePositions[i].position + 
                       (seg / segTotal) * (milestonePositions[i + 1].position - milestonePositions[i].position);
            segmentFound = true;
            break;
          }
        }

        // If beyond all milestones or no segment found
        if (!segmentFound && itemCount >= milestonePositions[milestonePositions.length - 1].qty) {
          fillWidth = barWidth;
        }
      }

      return (fillWidth / barWidth) * 100;
    } catch (error) {
      console.error('Error calculating progress percentage:', error);
      return 0;
    }
  }

  updateProgressTitle(itemCount) {
    try {
      const progressTitle = document.querySelector('.cart-drawer-new__progress-title');
      if (!progressTitle) {
        console.warn('Progress title element not found');
        return;
      }

      const validMilestones = this.getValidMilestones();

      if (validMilestones.length === 0) {
        progressTitle.textContent = this.settings.title || 'Add items to unlock rewards!';
        return;
      }

      // Build milestone text in format: "2+ (free shipping); 3+ (10% off); 5+ (15% off)"
      const milestoneParts = validMilestones.map(milestone => {
        const benefit = milestone.productTitle || milestone.gift;
          milestone.qty = milestone.qty - 1;
        return `${milestone.qty}+ (${benefit})`;
      });

      let titleText = milestoneParts.join('; ');
      
      // Add prefix if it exists and is not empty
      const prefix = (this.settings.prefix || '').trim();
      if (prefix !== '') {
        titleText = `${prefix} ${titleText}`;
      }

      progressTitle.textContent = titleText;
    } catch (error) {
      console.error('Error updating progress title:', error);
    }
  }

  updateMilestones(itemCount) {
    try {
      const validMilestones = this.getValidMilestones();

      // Then update the state of valid milestones
      validMilestones.forEach(milestone => {
        const milestoneEl = document.getElementById(`milestone-${milestone.index}`);
        if (milestoneEl) {
          const marker = milestoneEl.querySelector('.cart-drawer-new__milestone-marker');
          const giftText = milestoneEl.querySelector('.cart-drawer-new__milestone-gift');

          const completed = itemCount >= milestone.qty;

          if (completed) {
            milestoneEl.classList.add('achieved');
            milestoneEl.classList.remove('upcoming');
            if (marker) marker.classList.add('achieved');
            if (giftText) giftText.classList.add('achieved');
          } else {
            milestoneEl.classList.add('upcoming');
            milestoneEl.classList.remove('achieved');
            if (marker) marker.classList.remove('achieved');
            if (giftText) giftText.classList.remove('achieved');
          }
        }
      });
    } catch (error) {
      console.error('Error updating milestones:', error);
    }
  }

  updateProgressBar() {
    try {
      // Check if progress bar container exists
      const progressBarContainer = document.getElementById('cart-progress-bar');
      if (!progressBarContainer) {
        console.warn('Progress bar container not found');
        return;
      }

      const itemCount = this.getCartItemCount();
      const progressPercentage = this.getProgressPercentage(itemCount);

      console.log('Progress Bar Update:', {
        itemCount,
        progressPercentage,
        validMilestones: this.getValidMilestones()
      });

      // Update progress bar fill with your width adjustment logic
      const progressBarFill = document.getElementById('progress-bar-fill');
      if (progressBarFill) {
        if (progressPercentage === 100) {
          progressBarFill.style.width = '100%';
        } else if (itemCount < (this.settings.milestones[0]?.quantity || 0)) {
          progressBarFill.style.width = '6%';
        } else {
          progressBarFill.style.width = `${Math.max(0, progressPercentage)}%`;
        }
      }

      // Update progress title
      this.updateProgressTitle(itemCount);

      // Update milestones
      this.updateMilestones(itemCount);
    } catch (error) {
      console.error('Error updating progress bar:', error);
    }
  }

  // Method to safely check if element exists before updating
  safeElementUpdate(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
      callback(element);
    }
  }
}

// Initialize progress bar when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Wait for cart drawer to be fully loaded
  const waitForCartDrawer = setInterval(() => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      clearInterval(waitForCartDrawer);
      window.cartProgressBar = new CartProgressBar();
    }
  }, 100);
});

// Update progress bar on cart changes with error handling
document.addEventListener('cart:updated', () => {
  setTimeout(() => {
    if (window.cartProgressBar && typeof window.cartProgressBar.updateProgressBar === 'function') {
      try {
        window.cartProgressBar.updateProgressBar();
      } catch (error) {
        console.error('Error in cart:updated handler:', error);
      }
    }
  }, 500);
});

// Helper function to manually update progress bar with error handling
function updateCartProgressBar() {
  if (window.cartProgressBar && typeof window.cartProgressBar.updateProgressBar === 'function') {
    try {
      window.cartProgressBar.updateProgressBar();
    } catch (error) {
      console.error('Error updating cart progress bar:', error);
    }
  }
}

// Fix for the cart update error in your existing code
// Add this to patch the problematic getSectionInnerHTML method
function patchCartDrawerErrors() {
  const originalGetSectionInnerHTML = HTMLElement.prototype.getSectionInnerHTML;

  if (originalGetSectionInnerHTML) {
    HTMLElement.prototype.getSectionInnerHTML = function(html, selector) {
      try {
        const element = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector);

        return element ? element.innerHTML : '';
      } catch (error) {
        console.error('Error in getSectionInnerHTML:', error);
        return '';
      }
    };
  }
}

// Apply the patch when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  patchCartDrawerErrors();
});

// Birdie Plus Subscription Handler
class BirdiePlusSubscriptionHandler {
  constructor() {
    this.isProcessing = false;
    this.processingTimeout = null;
    this.isAddingSubscription = false;
    this.subscriptionCheckInProgress = false;
    this.debounceTimeout = null;
    this.init();
  }

  init() {
    this.bindEvents();
    // Check for existing birdie-plus items on page load
    setTimeout(() => {
      this.checkForBirdiePlusItems();
    }, 1000);
  }

  bindEvents() {
    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      setTimeout(() => {
        this.checkForBirdiePlusItems();
      }, 500);
    });

    // Listen for cart drawer updates
    document.addEventListener('cart-drawer:updated', () => {
      setTimeout(() => {
        this.checkForBirdiePlusItems();
      }, 500);
    });
  }

  checkForBirdiePlusItems() {
    // Debounce the check to prevent rapid-fire calls
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    
    this.debounceTimeout = setTimeout(() => {
      this.performBirdiePlusCheck();
    }, 500); // 500ms debounce
  }

  performBirdiePlusCheck() {
    try {
      // Prevent multiple simultaneous checks with global lock
      if (this.isProcessing || this.subscriptionCheckInProgress) {
        console.log('Already processing birdie-plus check, skipping...');
        return;
      }

      this.isProcessing = true;
      this.subscriptionCheckInProgress = true;
      
      // Clear any existing timeout
      if (this.processingTimeout) {
        clearTimeout(this.processingTimeout);
      }

      // Set timeout to reset processing flags
      this.processingTimeout = setTimeout(() => {
        this.isProcessing = false;
        this.subscriptionCheckInProgress = false;
      }, 3000); // Increased timeout to prevent race conditions

      const cartItems = document.querySelectorAll('.cart-item');
      let hasBirdiePlus = false;

      console.log('Checking for birdie-plus items...');
      console.log('Total cart items:', cartItems.length);

      cartItems.forEach((item, index) => {
        const title = item.dataset.title || '';
        const properties = item.dataset.properties || '';
        
        // Check for birdie-plus in various ways
        const hasBirdiePlusInTitle = title.toLowerCase().includes('birdie-plus');
        const hasBirdiePlusInProperties = properties.toLowerCase().includes('birdie-plus');
        const hasBirdiePlusClass = item.classList.contains('subscribe-birdie-plus');
        
        // Check if any child element has the birdie-plus class
        const hasBirdiePlusChild = item.querySelector('.subscribe-birdie-plus') !== null;
        
        // Check the quantity wrapper for birdie-plus class
        const quantityWrapper = item.querySelector('.cart-item__quantity-wrapper');
        const hasBirdiePlusInWrapper = quantityWrapper && quantityWrapper.classList.contains('birdie-plus');
        
        console.log(`Item ${index}:`, {
          title: title,
          properties: properties,
          hasBirdiePlusInTitle: hasBirdiePlusInTitle,
          hasBirdiePlusInProperties: hasBirdiePlusInProperties,
          hasBirdiePlusClass: hasBirdiePlusClass,
          hasBirdiePlusChild: hasBirdiePlusChild,
          hasBirdiePlusInWrapper: hasBirdiePlusInWrapper,
          allClasses: Array.from(item.classList),
          quantityWrapperClasses: quantityWrapper ? Array.from(quantityWrapper.classList) : []
        });
        
        if (hasBirdiePlusInTitle || 
            hasBirdiePlusInProperties ||
            hasBirdiePlusClass ||
            hasBirdiePlusChild ||
            hasBirdiePlusInWrapper) {
          hasBirdiePlus = true;
          console.log('Found birdie-plus item!');
        }
      });

      console.log('Has birdie-plus items:', hasBirdiePlus);

      if (hasBirdiePlus) {
        this.ensureSubscriptionExists();
      } else {
        this.removeSubscriptionIfExists();
      }
      
      // Reset flags when check completes
      this.isProcessing = false;
      this.subscriptionCheckInProgress = false;
    } catch (error) {
      console.error('Error checking for birdie-plus items:', error);
      // Reset flags on error too
      this.isProcessing = false;
      this.subscriptionCheckInProgress = false;
    }
  }

  async ensureSubscriptionExists() {
    try {
      // First check the current cart data from the server
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      
      // Check if subscription already exists in cart data
      const hasSubscriptionInCart = cartData.items.some(item => 
        item.product_id === 40687211151535 || // subscription product ID
        item.title.toLowerCase().includes('subscription') ||
        item.properties && Object.values(item.properties).some(prop => 
          prop && prop.toString().toLowerCase().includes('subscription')
        )
      );
      
      console.log('Cart data check:', {
        totalItems: cartData.items.length,
        hasSubscriptionInCart: hasSubscriptionInCart,
        cartItems: cartData.items.map(item => ({
          id: item.product_id,
          title: item.title,
          properties: item.properties
        }))
      });
      
      if (!hasSubscriptionInCart) {
        console.log('Adding subscription for birdie-plus items...');
        // Add a small delay to prevent race conditions
        await new Promise(resolve => setTimeout(resolve, 100));
        await this.addSubscription();
      } else {
        console.log('Subscription already exists in cart, skipping...');
      }
    } catch (error) {
      console.error('Error ensuring subscription exists:', error);
      // Fallback to DOM-based check if server check fails
      this.ensureSubscriptionExistsFallback();
    }
  }

  ensureSubscriptionExistsFallback() {
    try {
      // Fallback: Check if subscription already exists by looking for subscription items
      const existingSubscriptions = document.querySelectorAll('.cart-item.subscription');
      const subscriptionItems = document.querySelectorAll('[data-subscription="true"]');
      
      // Also check for items with subscription-related properties
      const allCartItems = document.querySelectorAll('.cart-item');
      let hasSubscription = false;
      
      allCartItems.forEach(item => {
        const title = item.dataset.title || '';
        const properties = item.dataset.properties || '';
        
        // Check if this is a subscription item
        if (title.toLowerCase().includes('subscription') || 
            properties.toLowerCase().includes('subscription') ||
            item.classList.contains('subscription') ||
            item.querySelector('[data-subscription="true"]')) {
          hasSubscription = true;
        }
      });
      
      console.log('Fallback subscription check:', {
        existingSubscriptions: existingSubscriptions.length,
        subscriptionItems: subscriptionItems.length,
        hasSubscription: hasSubscription
      });
      
      if (!hasSubscription && existingSubscriptions.length === 0 && subscriptionItems.length === 0) {
        console.log('Adding subscription for birdie-plus items (fallback)...');
        this.addSubscription();
      } else {
        console.log('Subscription already exists, skipping (fallback)...');
      }
    } catch (error) {
      console.error('Error in fallback subscription check:', error);
    }
  }

  removeSubscriptionIfExists() {
    try {
      const existingSubscription = document.querySelector('.cart-item.subscription');
      
      if (existingSubscription) {
        console.log('Removing subscription as no birdie-plus items found...');
        this.removeSubscription();
      }
      
      // Reset session flag when no birdie-plus items are found
      window.subscriptionAddedThisSession = false;
      console.log('🔄 Reset session flag - no birdie-plus items found');
    } catch (error) {
      console.error('Error removing subscription:', error);
    }
  }

  async addSubscription() {
    // Aggressive duplicate prevention
    if (this.isAddingSubscription || window.globalSubscriptionLock || window.subscriptionAddedThisSession) {
      console.log('Subscription already being added or already added this session, skipping...');
      return;
    }
    
    // Set all locks immediately
    this.isAddingSubscription = true;
    window.globalSubscriptionLock = true;
    window.subscriptionAddedThisSession = true;
    
    console.log('🔒 LOCKED: Preventing multiple subscriptions');
    
    try {
      // Use the changeSubscriptionQuantity method from the provided reference
      await this.changeSubscriptionQuantity(1);
      console.log('✅ Subscription added successfully');
    } catch (error) {
      console.error('❌ Error adding subscription:', error);
      // Reset session flag on error to allow retry
      window.subscriptionAddedThisSession = false;
    } finally {
      // Reset local flags after completion
      setTimeout(() => {
        this.isAddingSubscription = false;
        window.globalSubscriptionLock = false;
        console.log('🔓 UNLOCKED: Subscription process completed');
      }, 3000);
    }
  }

  removeSubscription() {
    // Use the changeSubscriptionQuantity method to remove subscription
    this.changeSubscriptionQuantity(-1);
  }

  async changeSubscriptionQuantity(numberOfSubscriptions) {
    if (numberOfSubscriptions < 0) {
      let subscriptionItem = document.querySelector(".cart-item.subscription");
      let subKeys = [];
      let count = 0;
    
      if (subscriptionItem) {
        Object.keys(subscriptionItem.dataset).forEach(item => {
          if (item.includes('key') && count < 1) {
            subKeys.push(subscriptionItem.dataset[item]);
            count += 1;
          }
        });

        this.updateQuantity('', 0, "subscription", '', subKeys);
      }
    } else {
      // Check if subscription already exists before adding
      const existingSubscription = document.querySelector(".cart-item.subscription");
      if (existingSubscription) {
        console.log('❌ Subscription already exists in cart, skipping addition...');
        this.isAddingSubscription = false;
        window.globalSubscriptionLock = false;
        window.subscriptionAddedThisSession = false;
        return;
      }

      // Double-check with server-side cart data to prevent race conditions
      try {
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        const hasSubscriptionInCart = cartData.items.some(item => 
          item.product_id === 40687211151535 || // subscription product ID
          item.title.toLowerCase().includes('subscription')
        );
        
        if (hasSubscriptionInCart) {
          console.log('❌ Subscription already exists in server cart, skipping addition...');
          this.isAddingSubscription = false;
          window.globalSubscriptionLock = false;
          window.subscriptionAddedThisSession = false;
          return;
        }
      } catch (error) {
        console.warn('Could not verify subscription with server, proceeding with caution...');
      }
      
      let uniqueID = () => {
        function chr4(){
          return (Date.now() * Math.random()).toString(16).slice(0,4).toUpperCase();
        }
        return chr4() + '-' + chr4() + '-' + chr4()
      }

      // annual subscription
      let birdieSubscription = {
          dataset: {
            selling: "1001423023",
            subscribe: "40687211151535"
          }
        }

      let formItems = []

      // Only add one subscription, not multiple
      let UID = uniqueID()
      formItems.push({
        id: birdieSubscription.dataset.subscribe,
        selling_plan: birdieSubscription.dataset.selling,
        quantity: 1,
        properties: {
          '_UID': UID,
          '_theme': 'med'
        }
      })

      let formData = {
        items: formItems,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      };

      console.log('Adding subscription to cart...', formData);

      // Final check before adding subscription
      if (window.globalSubscriptionLock && !this.isAddingSubscription) {
        console.log('Global lock detected, another subscription is being added, skipping...');
        return;
      }

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          console.log('Subscription added successfully:', parsedState);

          // Update cart display using the existing cart update mechanism
          this.updateCartDisplay(parsedState);

          // Trigger cart update events
          if (typeof publish !== 'undefined' && PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "birdie-plus-subscription" });
          }

          // Dispatch custom event for cart updates
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { source: 'birdie-plus-subscription' }
          }));

        })
        .catch((e) => {
          console.error('Error adding subscription:', e);
          this.querySelectorAll(".loading-overlay").forEach((overlay) =>
            overlay.classList.add("hidden")
          );
          const errors =
            document.getElementById("cart-errors") ||
            document.getElementById("CartDrawer-CartErrors");
          if (errors) {
            errors.textContent = window.cartStrings?.error || 'Error adding subscription';
          }
        })
        .finally(() => {
          window.setTimeout(() => {
            this.endLoad();
          }, 150);
        });
    }
  }

  async updateCartDisplay(parsedState) {
    try {
      console.log('Updating cart display...', parsedState);

      // Force a complete cart refresh by fetching the cart drawer section
      const cartDrawerResponse = await fetch('/cart?section_id=cart-drawer');
      const cartDrawerHtml = await cartDrawerResponse.text();
      
      // Parse the response and update the cart drawer
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartDrawerHtml, 'text/html');
      
      // Update the main cart drawer content
      const newCartDrawer = doc.querySelector('#CartDrawer');
      const currentCartDrawer = document.querySelector('#CartDrawer');
      
      if (newCartDrawer && currentCartDrawer) {
        currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
        console.log('Cart drawer content updated');
      }

      // Update cart icon bubble
      const cartIconResponse = await fetch('/cart?section_id=cart-icon-bubble');
      const cartIconHtml = await cartIconResponse.text();
      const cartIconDoc = parser.parseFromString(cartIconHtml, 'text/html');
      const newCartIcon = cartIconDoc.querySelector('#cart-icon-bubble');
      const currentCartIcon = document.querySelector('#cart-icon-bubble');
      
      if (newCartIcon && currentCartIcon) {
        currentCartIcon.innerHTML = newCartIcon.innerHTML;
        console.log('Cart icon updated');
      }

      // Update cart footer if it exists
      const cartFooterResponse = await fetch('/cart?section_id=main-cart-footer');
      const cartFooterHtml = await cartFooterResponse.text();
      const cartFooterDoc = parser.parseFromString(cartFooterHtml, 'text/html');
      const newCartFooter = cartFooterDoc.querySelector('#main-cart-footer');
      const currentCartFooter = document.querySelector('#main-cart-footer');
      
      if (newCartFooter && currentCartFooter) {
        currentCartFooter.innerHTML = newCartFooter.innerHTML;
        console.log('Cart footer updated');
      }

      // Update cart empty state
      const cartDrawerWrapper = document.querySelector("cart-drawer");
      if (cartDrawerWrapper) {
        cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);
      }

      console.log('Cart display updated successfully');

      if (typeof window.applySpringCopyFromCart === 'function') {
        window.applySpringCopyFromCart();
      }
    } catch (error) {
      console.error('Error updating cart display:', error);
      
      // Fallback to the original method if the new one fails
      this.updateCartDisplayFallback(parsedState);
    }
  }

  updateCartDisplayFallback(parsedState) {
    try {
      const items = document.querySelectorAll(".cart-item");

      // Update cart empty state
      const cartDrawerWrapper = document.querySelector("cart-drawer");
      const cartFooter = document.getElementById("main-cart-footer");

      if (cartDrawerWrapper) {
        cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);
      }
      if (cartFooter) {
        cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
      }

      // Update cart sections
      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document
            .getElementById(section.id)
            ?.querySelector(section.selector) ||
          document.getElementById(section.id);
        
        if (elementToReplace && parsedState.sections[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      });

      // Update cart icon bubble
      if (parsedState.sections['cart-icon-bubble']) {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
          cartIconBubble.innerHTML = this.getSectionInnerHTML(
            parsedState.sections['cart-icon-bubble'],
            '.shopify-section'
          );
        }
      }

      console.log('Cart display updated successfully (fallback)');

      if (typeof window.applySpringCopyFromCart === 'function') {
        window.applySpringCopyFromCart();
      }
    } catch (error) {
      console.error('Error updating cart display (fallback):', error);
    }
  }

  updateQuantity(line, quantity, name, key, subKeys) {
    // Use the existing cart update functionality
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (cartItems && cartItems.updateQuantity) {
      if (subKeys && subKeys.length > 0) {
        cartItems.updateQuantity(line, quantity, name, subKeys[0]);
      } else {
        cartItems.updateQuantity(line, quantity, name, key);
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id || "main-cart-items",
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id || "main-cart-footer",
        selector: ".js-contents",
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  endLoad() {
    document.querySelector(".birdie-loader__inner").style.display = "none";
  }
}

// Global subscription lock to prevent multiple subscriptions
window.globalSubscriptionLock = false;
window.subscriptionAddedThisSession = false;

// Initialize Birdie Plus Subscription Handler
document.addEventListener('DOMContentLoaded', () => {
  window.birdiePlusSubscriptionHandler = new BirdiePlusSubscriptionHandler();
});

// Manual trigger for testing
window.testBirdiePlusDetection = function() {
  console.log('Manual test of birdie-plus detection...');
  if (window.birdiePlusSubscriptionHandler) {
    window.birdiePlusSubscriptionHandler.checkForBirdiePlusItems();
  } else {
    console.log('Birdie Plus Subscription Handler not initialized yet');
  }
};

// Manual reset function for debugging
window.resetSubscriptionLocks = function() {
  console.log('🔄 Resetting all subscription locks...');
  window.globalSubscriptionLock = false;
  window.subscriptionAddedThisSession = false;
  if (window.birdiePlusSubscriptionHandler) {
    window.birdiePlusSubscriptionHandler.isProcessing = false;
    window.birdiePlusSubscriptionHandler.subscriptionCheckInProgress = false;
    window.birdiePlusSubscriptionHandler.isAddingSubscription = false;
  }
  console.log('✅ All locks reset');
};

/**
 * Cart attribute igTestGroups must match the B2G1 Shopify Function extension.
 * Run theme line-split / free-line logic only when the cart is in Group B (or unset).
 * Group A uses the escalating discount function — no client-side free lines.
 * Keep in sync with: extensions/birdie-buy2-get1-free/src/cart_lines_discounts_generate_run.ts
 */
const IG_GROUP_B_FOR_B2G1_THEME = {
  groupB: true,
  '7a3a6fca109e': true,
};

function shouldRunBuyXGetYFreeSync(igTestGroupsValue) {
  if (igTestGroupsValue == null || igTestGroupsValue === '') {
    return true;
  }
  return !!IG_GROUP_B_FOR_B2G1_THEME[igTestGroupsValue];
}

// Buy 2 Get 1 Free — auto-add/remove free items with color-aware matching
const BuyXGetYFreeManager = {
  isSyncing: false,
  pendingSync: false,
  lastAddedVariantId: null,
  PROP_KEY: '_buy_x_get_y_free',
  SYNC_HEADER: 'X-Buy-X-Get-Y-Sync',
  /** Merged into theme JSON config by ig-offer-orchestrator (B2G1 vs B3G1). */
  _configOverrides: null,

  overrideConfig(overrides) {
    this._configOverrides = { ...(this._configOverrides || {}), ...overrides };
  },

  getConfig() {
    try {
      const el = document.querySelector('[data-buy-x-get-y-free]');
      if (!el) return null;
      const config = JSON.parse(el.textContent);
      if (!config.enabled || !config.eligible_products?.length) return null;
      if (this._configOverrides) {
        Object.assign(config, this._configOverrides);
      }
      return config;
    } catch (e) {
      console.error('[B2G1] Failed to parse config:', e);
      return null;
    }
  },

  async fetchCart() {
    const resp = await fetch('/cart.js', {
      headers: { [this.SYNC_HEADER]: '1' }
    });
    return resp.json();
  },

  isFree(item) {
    return item.properties && item.properties[this.PROP_KEY] !== undefined;
  },

  calculateChanges(cartData, config) {
    const triggerQty = config.quantity;
    const maxFree = config.max_free_items ?? 4;
    const eligibleProducts = config.eligible_products.map(Number);

    const toRemove = [];
    const toSplit = [];

    for (const productId of eligibleProducts) {
      const paidLines = cartData.items.filter(
        item => Number(item.product_id) === productId && !this.isFree(item)
      );
      const freeLines = cartData.items.filter(
        item => Number(item.product_id) === productId && this.isFree(item)
      );

      const paidQty = paidLines.reduce((sum, item) => sum + item.quantity, 0);
      const currentFreeQty = freeLines.reduce((sum, item) => sum + item.quantity, 0);
      const totalQty = paidQty + currentFreeQty;

      // Stacking: every triggerQty items earns 1 free, capped at maxFree
      const targetFreeQty = totalQty >= triggerQty
        ? Math.min(Math.floor(totalQty / triggerQty), maxFree)
        : 0;

      if (currentFreeQty > targetFreeQty) {
        let excess = currentFreeQty - targetFreeQty;

        // Remove excess free items — prioritize removing free items whose
        // variant has no remaining paid counterpart (user likely removed those)
        const paidVariantIds = new Set(paidLines.map(l => l.variant_id));
        const sortedFree = [...freeLines].sort((a, b) => {
          const aHasPaid = paidVariantIds.has(a.variant_id) ? 1 : 0;
          const bHasPaid = paidVariantIds.has(b.variant_id) ? 1 : 0;
          return aHasPaid - bHasPaid;
        });

        for (const line of sortedFree) {
          if (excess <= 0) break;
          const removeQty = Math.min(line.quantity, excess);
          toRemove.push({ key: line.key, newQty: line.quantity - removeQty });
          excess -= removeQty;
        }
      } else if (currentFreeQty < targetFreeQty && paidQty >= triggerQty) {
        let remainingSplit = targetFreeQty - currentFreeQty;

        // For the first split, prefer the variant that was just added to cart
        let preferredLine = null;
        if (this.lastAddedVariantId) {
          preferredLine = paidLines.find(l => l.variant_id === this.lastAddedVariantId);
          this.lastAddedVariantId = null;
        }

        // Build a working copy of paid line quantities we can "spend" from
        const available = paidLines.map(l => ({
          key: l.key,
          variantId: l.variant_id,
          qty: l.quantity,
          isPreferred: l === preferredLine
        }));

        // Put preferred line first, then sort rest by quantity descending
        available.sort((a, b) => {
          if (a.isPreferred) return -1;
          if (b.isPreferred) return 1;
          return b.qty - a.qty;
        });

        for (const line of available) {
          if (remainingSplit <= 0) break;
          if (line.qty <= 0) continue;

          const takeFromLine = Math.min(line.qty, remainingSplit);

          toSplit.push({
            reduceKey: line.key,
            reduceToQty: line.qty - takeFromLine,
            addVariantId: line.variantId,
            addQty: takeFromLine,
            productId: productId
          });

          line.qty -= takeFromLine;
          remainingSplit -= takeFromLine;
        }
      }
    }

    return { toRemove, toSplit };
  },

  async removeItems(toRemove) {
    const updates = {};
    for (const item of toRemove) {
      updates[item.key] = item.newQty;
    }

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        [this.SYNC_HEADER]: '1'
      },
      body: JSON.stringify({ updates })
    });
  },

  async splitItems(toSplit) {
    for (const split of toSplit) {
      // Reduce the paid line qty (or remove entirely if qty reaches 0)
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          [this.SYNC_HEADER]: '1'
        },
        body: JSON.stringify({
          id: split.reduceKey,
          quantity: split.reduceToQty
        })
      });

      // Add each free item individually with a unique property value
      // so Shopify creates separate cart lines instead of merging them
      for (let i = 0; i < split.addQty; i++) {
        const uniqueId = `${split.productId}_${Date.now()}_${i}`;
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            [this.SYNC_HEADER]: '1'
          },
          body: JSON.stringify({
            items: [{
              id: split.addVariantId,
              quantity: 1,
              properties: { [this.PROP_KEY]: uniqueId }
            }]
          })
        });
      }
    }
  },

  async refreshCartUI() {
    try {
      const response = await fetch('/cart?section_id=cart-drawer', {
        headers: { [this.SYNC_HEADER]: '1' }
      });
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Replace the full drawer inner content so the empty-state HTML is included
      const newDrawerInner = doc.querySelector('.drawer__inner');
      const currentDrawerInner = document.querySelector('.drawer__inner');
      if (newDrawerInner && currentDrawerInner) {
        currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
      }

      // Sync the is-empty class on the cart-drawer wrapper by checking
      // whether the server-rendered markup contains any cart items
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const newCartDrawerWrapper = doc.querySelector('cart-drawer');
      if (cartDrawerWrapper && newCartDrawerWrapper) {
        const isEmpty = newCartDrawerWrapper.classList.contains('is-empty');
        cartDrawerWrapper.classList.toggle('is-empty', isEmpty);
      }

      // Update cart icon bubble
      const cartIconResp = await fetch('/cart?section_id=cart-icon-bubble', {
        headers: { [this.SYNC_HEADER]: '1' }
      });
      const iconHtml = await cartIconResp.text();
      const iconDoc = new DOMParser().parseFromString(iconHtml, 'text/html');
      const newIcon = iconDoc.querySelector('.shopify-section');
      const currentIcon = document.querySelector('#cart-icon-bubble');
      if (newIcon && currentIcon) {
        currentIcon.innerHTML = newIcon.innerHTML;
      }

      // Update cart footer totals
      const footerResp = await fetch('/cart?section_id=main-cart-footer', {
        headers: { [this.SYNC_HEADER]: '1' }
      });
      const footerHtml = await footerResp.text();
      const footerDoc = new DOMParser().parseFromString(footerHtml, 'text/html');
      const newFooter = footerDoc.querySelector('.js-contents');
      const currentFooter = document.querySelector('#main-cart-footer .js-contents');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      }

      // Re-initialize color swatch handler after DOM update
      if (typeof ColorSwatchHandler !== 'undefined') {
        new ColorSwatchHandler();
      }

      // Trigger cart update event so other components refresh (progress bar, etc.)
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'buy-x-get-y-free' });
      }

      if (typeof window.applySpringCopyFromCart === 'function') {
        window.applySpringCopyFromCart();
      }
    } catch (e) {
      console.error('[B2G1] Error refreshing cart UI:', e);
    }
  },

  showDrawerSyncOverlay() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.classList.contains('b2g1-syncing')) return;
    drawer.classList.add('b2g1-syncing');
  },

  hideDrawerSyncOverlay() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('b2g1-syncing');
  },

  getLoaderType() {
    const config = this.getConfig();
    return config?.loader_type || 'cart';
  },

  showSplitLoading(message) {
    this.hideSplitLoading();
    const container = document.getElementById('CartDrawer-CartItems')
      || document.getElementById('main-cart-items');
    if (!container) return;

    const text = message || 'Updating your cart with free item';
    const loaderType = this.getLoaderType();

    if (loaderType === 'line_item') {
      container.classList.add('cart__items--disabled');
      document.querySelectorAll('.cart-item').forEach(item => {
        item.classList.add('loading');
        const overlay = item.querySelector('.cart-item__loading-overlay');
        if (overlay) overlay.style.display = 'flex';
      });

      const banner = document.createElement('div');
      banner.className = 'b2g1-split-banner';
      banner.innerHTML = '<span class="b2g1-split-spinner"></span> ' + text;
      container.insertBefore(banner, container.firstChild);
    } else {
      container.style.position = 'relative';
      const overlay = document.createElement('div');
      overlay.className = 'b2g1-cart-overlay';
      overlay.innerHTML = `
        <span class="b2g1-cart-overlay__spinner"></span>
        <span class="b2g1-cart-overlay__text">${text}</span>
      `;
      container.appendChild(overlay);
    }
  },

  hideSplitLoading() {
    document.querySelectorAll('.b2g1-split-banner').forEach(el => el.remove());
    document.querySelectorAll('.b2g1-cart-overlay').forEach(el => el.remove());
    this.hideDrawerSyncOverlay();

    const container = document.getElementById('CartDrawer-CartItems')
      || document.getElementById('main-cart-items');
    if (container) container.classList.remove('cart__items--disabled');

    document.querySelectorAll('.cart-item.loading').forEach(item => {
      item.classList.remove('loading');
      const overlay = item.querySelector('.cart-item__loading-overlay');
      if (overlay) overlay.style.display = 'none';
    });
  },

  showEmptyCartState() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.classList.add('is-empty');

    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems) cartDrawerItems.classList.add('is-empty');

    // Update the icon bubble count to 0
    const bubbleCount = document.querySelector('#cart-icon-bubble .cart-count-bubble span');
    if (bubbleCount) bubbleCount.textContent = '0';
  },

  // Instantly animate free item elements out of the DOM before backend removal
  animateOutFreeItems(toRemove) {
    const keysToRemove = toRemove
      .filter(r => r.newQty === 0)
      .map(r => r.key);

    if (!keysToRemove.length) return Promise.resolve();

    const elements = [];
    document.querySelectorAll('.cart-item[data-b2g1-free]').forEach(el => {
      if (keysToRemove.includes(el.getAttribute('data-key'))) {
        elements.push(el);
      }
    });

    if (!elements.length) return Promise.resolve();

    return new Promise(resolve => {
      elements.forEach(el => {
        // Lock current height so the collapse transition has a start value
        el.style.maxHeight = el.offsetHeight + 'px';
        el.style.transition = 'none';
        // Force reflow to apply the fixed height before animating
        void el.offsetHeight;
        // Re-enable transition and trigger collapse
        el.style.transition = '';
        el.classList.add('b2g1-removing');
      });
      setTimeout(resolve, 380);
    });
  },

  async sync() {
    if (this.isSyncing) {
      this.pendingSync = true;
      return;
    }
    // Intelligems: only run line-split sync when the active offer is B2G1 or B3G1.
    const igOffer = window.__igActiveOffer;
    if (igOffer && igOffer !== 'buy_2_get_1' && igOffer !== 'buy_3_get_1') {
      return;
    }

    this.isSyncing = true;

    try {
      const config = this.getConfig();
      if (!config) return;

      const cartData = await this.fetchCart();

      var igGroup = cartData.attributes && cartData.attributes.igTestGroups;
      if (!shouldRunBuyXGetYFreeSync(igGroup)) {
        return;
      }

      const changes = this.calculateChanges(cartData, config);
      const hasRemovals = changes.toRemove.length > 0;
      const hasSplits = changes.toSplit.length > 0;

      // Animate out free items instantly, then do backend work
      if (hasRemovals) {
        await this.animateOutFreeItems(changes.toRemove);
      }

      // Show empty state early if cart will be empty after removals
      if (hasRemovals && !hasSplits) {
        const totalItemsAfter = cartData.items.reduce((sum, item) => {
          const removal = changes.toRemove.find(r => r.key === item.key);
          if (removal) return sum + removal.newQty;
          return sum + item.quantity;
        }, 0);

        if (totalItemsAfter === 0) {
          this.showEmptyCartState();
        }
      }

      if (hasSplits) {
        this.showSplitLoading('Updating your cart with free item');
      }

      if (hasRemovals) {
        await this.removeItems(changes.toRemove);
      }
      if (hasSplits) {
        await this.splitItems(changes.toSplit);
      }

      if (hasRemovals || hasSplits) {
        await this.refreshCartUI();
      }
    } catch (e) {
      console.error('[B2G1] Sync error:', e);
    } finally {
      this.hideSplitLoading();
      this.isSyncing = false;
      if (this.pendingSync) {
        this.pendingSync = false;
        this.sync();
      }
    }
  }
};

// Expose globally so other handlers can reference it
window.BuyXGetYFreeManager = BuyXGetYFreeManager;

// Run sync when cart drawer opens
document.addEventListener('cart-drawer:opened', () => {
  setTimeout(() => {
    BuyXGetYFreeManager.sync();
  }, 300);
});

// Also subscribe to Shopify PUB_SUB cart update events as a backup trigger.
// product-form.js publishes cartUpdate after add-to-cart completes.
if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    // Skip events dispatched by our own sync to avoid loops
    if (event.source === 'buy-x-get-y-free') return;
    setTimeout(() => {
      BuyXGetYFreeManager.sync();
    }, 50);
  });
}

// Manual test function for cart drawer overlay
window.testCartDrawerOverlay = function() {
  console.log('🧪 Testing cart drawer overlay...');
  const cartDrawer = document.querySelector('cart-drawer');
  const overlay = document.querySelector('#CartDrawer-Overlay');
  
  if (cartDrawer) {
    console.log('✅ Cart drawer found');
    if (overlay) {
      console.log('✅ Overlay found');
      console.log('Testing overlay click...');
      overlay.click();
    } else {
      console.log('❌ Overlay not found');
    }
  } else {
    console.log('❌ Cart drawer not found');
  }
};

// Force check when cart drawer is opened
document.addEventListener('cart-drawer:opened', () => {
  setTimeout(() => {
    if (window.birdiePlusSubscriptionHandler) {
      console.log('Cart drawer opened - checking for birdie-plus items...');
      window.birdiePlusSubscriptionHandler.checkForBirdiePlusItems();
    }
  }, 500);
});